export enum InputTypeCode {
  BACKSPACE = "Backspace",
  ENTER = "Enter",
  PASTE = "insertFromPaste"
}
